import { useThemePalette } from 'common/hooks/theme_palette';
import ConfirmationModal from 'components/Molecules/Models/ConfirmationModal'
import React from 'react'

export default function DeleteModel({ openModel, setOpenModel, handleUpdate, userType }) {
    const { red } = useThemePalette()

    return <>
        <ConfirmationModal
            open={openModel?.state}
            setOpen={setOpenModel}
            handleConfirmation={_ => {
                handleUpdate()
                setOpenModel({ state: false, customerId: false, action: false })
            }}
            text={[
                `Delete ${userType} Account`,
                `Are you sure you want to delete this ${userType} account?`
            ]}
            textStyle={{ color: red, fontSize: '32px', fontWeight: 500 }}
            confirmBtnTitle="Delete"
            btnStyle={{
                backgroundColor: red,
                "&:hover": {
                    backgroundColor: red,
                },
                color: "white",
            }}
        />
    </>
}
